<form (ngSubmit)="submit()" novalidate [formGroup]="form">
  <ion-list class="disable-background-color">
    <ion-item class="disable-background-color">
      <ion-icon name="at-circle-outline"></ion-icon>
      <ion-label floating>
        @if (formErrors.has('email')) {
          <span color="danger"><br />{{formErrors.get('email')}}</span>
        }
      </ion-label>
      <ion-input formControlName="email" type="email" [placeholder]="emailPlaceHolder"></ion-input>
    </ion-item>

    <ion-item class="disable-background-color">
      <ion-icon name="lock-closed-outline"></ion-icon>
      <ion-label floating>
        @if (formErrors.has('password')) {
          <span color="danger"><br />{{formErrors.get('password')}}</span>
        }
      </ion-label>
      <ion-input formControlName="password" type="password" [placeholder]="passwordPlaceHolder"></ion-input>
    </ion-item>
  </ion-list>

  <div padding>
    <ion-button type="submit" [disabled]="!form.valid" ion-button color="primary" expand="block">
      {{ 'Auth.Login' | translate }}
    </ion-button>
  </div>
</form>